import { isArray } from './is-array';

export function isObject<T>(obj: object | T): obj is Record<string, any> {
  if (obj === null) {
    return false;
  }

  if (typeof obj === 'function') {
    return false;
  }

  if (isArray(obj)) {
    return false;
  }

  return typeof obj === 'object';
}
